/* Tease Tea quiz result page. Two jobs only.
   1. Put the first name from the URL into the Result Summary.
   2. Read her quiz answers back as chips, from a strict whitelist.
   The offer itself needs NO JavaScript: the Buy Box, the Closing CTA and the
   Sticky Buy Bar all render their price and their checkout link in Liquid.
   The bar's show/hide is the only offer behaviour left here.

   IT RUNS ONCE, however many sections load it. Every section carries a copy of
   this tag so it can be dropped on any template and still work, and browser
   caching does NOT stop a second tag from EXECUTING. Ten copies used to mean
   ten scroll handlers. The guard below is what actually prevents that. */
(function () {
  'use strict';
  if (window.__ttq2) { window.__ttq2.refresh(); return; }

  /* Strict whitelist. hasOwnProperty, so ?goal=constructor cannot reach
     Object.prototype and print "function Object() { [native code] }". */
  /* Keys are the REAL answers, lowercased, exactly as Clarflow sends them.
     Read off the live funnel on 2026-09-10: its variables are primary_need,
     time_of_day, current_crutch, also_want, taste, day_shape, how_long and
     first_name, and the values arrive as full sentences, not slugs. An earlier
     version keyed this on short slugs like "sleep", which could never have
     matched a real visitor. The short spellings are kept as aliases so a
     hand-built test link still works. */
  var SAID = {
    primary_need: {
      'sleep you can feel': 'Better sleep',
      'lighter after meals': 'Lighter after meals',
      'calmer evenings': 'Calmer evenings',
      'lift without the crash': 'Steadier energy',
      'glow and strong hair': 'Glow and strong hair',
      'fewer run down days': 'Fewer run-down days',
      'ten minutes that are mine': 'Ten minutes that are mine',
      sleep: 'Better sleep', meals: 'Lighter after meals',
      evenings: 'Calmer evenings', energy: 'Steadier energy',
      glow: 'Glow and strong hair', rundown: 'Fewer run-down days',
      time: 'Ten minutes that are mine'
    },
    current_crutch: {
      'honestly, nothing': 'Nothing so far',
      'coffee. a lot of it.': 'A lot of coffee',
      'vitamins': 'Vitamins',
      'sleep aids': 'Sleep aids',
      'a glass of wine': 'An evening glass',
      'skincare and supplements': 'Skincare and supplements',
      'antacids': 'Antacids',
      nothing: 'Nothing so far', coffee: 'A lot of coffee',
      sleepaids: 'Sleep aids', wine: 'An evening glass',
      skincare: 'Skincare and supplements'
    },
    how_long: {
      'it comes and goes': 'Comes and goes',
      'honestly, years. i have tried a lot.': 'Years of trying',
      'a few months now': 'A few months',
      'it has just started bothering me': 'Just started',
      years: 'Years of trying', months: 'A few months',
      comesandgoes: 'Comes and goes', 'new': 'Just started'
    }
  };

  /* Clarflow's own variable name first, then the short one used in testing. */
  var PARAMS = {
    primary_need: ['primary_need', 'goal'],
    current_crutch: ['current_crutch', 'using'],
    how_long: ['how_long']
  };

  function look(group, raw) {
    /* Trim and lowercase ONLY. Never strip characters until an unknown value
       happens to become a valid one: ?goal=sleep123 must render nothing. */
    var v = (raw || '').trim().toLowerCase();
    var g = SAID[group];
    return Object.prototype.hasOwnProperty.call(g, v) ? g[v] : null;
  }

  function params() { return new URLSearchParams(location.search); }

  function setName() {
    var raw = (params().get('name') || params().get('first_name') || '').trim();
    /* Letters, spaces, hyphens and apostrophes only, and short. */
    var name = /^[\p{L} '-]{1,24}$/u.test(raw) ? raw : '';
    var els = document.querySelectorAll('[data-ttq2-name]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = name ? name + ', ' : '';
    }
  }

  function setRecap() {
    var q = params(), out = [];
    Object.keys(PARAMS).forEach(function (k) {
      for (var i = 0; i < PARAMS[k].length; i++) {
        var label = look(k, q.get(PARAMS[k][i]));
        if (label) { out.push(label); return; }
      }
    });
    var boxes = document.querySelectorAll('[data-ttq2-recap]');
    for (var i = 0; i < boxes.length; i++) {
      var ul = boxes[i].querySelector('ul');
      if (!ul) continue;
      ul.textContent = '';
      if (!out.length) { boxes[i].hidden = true; continue; }
      out.forEach(function (txt) {
        var li = document.createElement('li');
        li.textContent = txt;            /* textContent, never innerHTML */
        ul.appendChild(li);
      });
      boxes[i].hidden = false;
    }
  }

  /* ---- Sticky Buy Bar. One handler pair for the life of the page. ---- */
  var hero = null, bar = null, ro = null, reserved = 0;

  function reserve() {
    if (!bar) return;
    /* Reserve the bar's REAL height, safe-area inset included, instead of a
       hard-coded 86px that a tall inset or a wrapped label would exceed. */
    var h = Math.ceil(bar.getBoundingClientRect().height);
    if (h && h !== reserved) {
      reserved = h;
      document.body.style.setProperty('--ttq2-bar', h + 'px');
    }
  }

  function sync() {
    if (!hero || !bar || !document.body.contains(hero)) {
      if (bar) bar.hidden = true;
      document.body.classList.remove('ttq2-stuck');
      return;
    }
    var gone = hero.getBoundingClientRect().bottom < 0;
    bar.hidden = !gone;
    document.body.classList.toggle('ttq2-stuck', gone);
    if (gone) reserve();
  }

  function refresh() {
    hero = document.querySelector('[data-ttq2-buy] .ttq2-cta');
    bar = document.querySelector('[data-ttq2-sticky]');
    if (ro) { ro.disconnect(); ro = null; }
    if (bar && 'ResizeObserver' in window) {
      ro = new ResizeObserver(reserve);
      ro.observe(bar);
    }
    setName();
    setRecap();
    sync();
  }

  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);

  window.__ttq2 = { refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
